// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-v-41d276aa]{overflow-y:hidden}.hospitalTitle[data-v-41d276aa]{text-align:center;margin:0;padding:3vh 0 5px;font-size:28px;color:#fff;letter-spacing:1px}.hospitalTitle p[data-v-41d276aa]{margin:0}.van-icon[data-v-41d276aa]{float:right;margin-right:1.5rem}.van-tabbar-item__icon img[data-v-41d276aa]{height:14px}.mainContainer[data-v-41d276aa]{position:relative;top:-2rem}[data-v-41d276aa]:export{green:#3f9775;white:#fff}", ""]);
// Exports
module.exports = exports;
